<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path fill="currentColor" d="M6.731 9.023l3.729-3.731.707.707-4.417 4.42-.019-.02-.019.02-2.42-2.42L5 7.292l1.731 1.73zM8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 1 8 0a8 8 0 0 1 0 16z" fill-rule="evenodd"/>
</svg>
